export default __webpack_public_path__ + "static/media/2_triptease.03cc7d9b.svg";